export const webCrypto = window.crypto;
